import React from 'react'
import { Stack, Tooltip, Typography } from "@mui/material";
import { makeTxtOverFLow } from '../utils/format';

function LabelTxt({ typoname, typodetail, overflow, namestyle, detailstyle, headcolor, txtcolor }) {

    return (
            <Stack direction={"row"} >
                <Typography color={headcolor} sx={namestyle} >{typoname}</Typography>
                <Tooltip title={typodetail}>
                    <Typography color={txtcolor} sx={detailstyle}>:&emsp;{makeTxtOverFLow(typodetail, overflow)}</Typography>
                </Tooltip>
            </Stack>

    )
}
export default LabelTxt